import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { AuthorizationService } from '../../../api-services/authorization/authorization.service';
import { AuthorizationModel } from '../../../api-services/authorization/models/authorization-model';
import { LoginModel } from '../../../shared/models/login.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class AuthService {
  public currentUser: Observable<AuthorizationModel>;
  isLoading$: Observable<boolean>;
  isLoadingSubject: BehaviorSubject<boolean>;
  private currentUserSubject: BehaviorSubject<AuthorizationModel>;
  private loggedInUserSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    JSON.parse(<string>localStorage.getItem('currentUser'))
  );
  public loggedInUser$ = this.loggedInUserSubject.asObservable();

  constructor(
    private authorizationService: AuthorizationService,
    private router: Router,
    private storageService: StorageService
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this.isLoadingSubject.asObservable();
    this.currentUserSubject = new BehaviorSubject<any>(
      JSON.parse(<string>localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  get currentUserValue(): AuthorizationModel {
    return this.currentUserSubject.value;
  }

  public setLoggedInUser(user: any): void {
    this.loggedInUserSubject.next(user);
  }

  login(userLogin: LoginModel): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.authorizationService.getToken(userLogin).pipe(
      switchMap((response) => {
        this.storageService.set('token', response[`access_token`]);
        return this.authorizationService
          .login(userLogin, response[`access_token`])
          .pipe(
            map((response) => {
              this.storageService.set('currentUser', JSON.stringify(response));
              // TODO remove unnecessary
              this.currentUserSubject.next(response);
              this.setLoggedInUser(response['user']);
              return response;
            })
          );
      }),
      catchError((err) => {
        return of(undefined);
      }),
      finalize(() => {
        this.isLoadingSubject.next(false);
      })
    );
  }

  logout() {
    this.storageService.clear().subscribe((res) => {
      if (res) {
        this.router.navigate(['/auth/login']);
      }
    });
  }

  registration(user: AuthorizationModel): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.authorizationService.register(user).pipe(
      map(() => {
        this.isLoadingSubject.next(false);
      }),
      catchError(() => {
        return of(undefined);
      }),
      finalize(() => {
        this.isLoadingSubject.next(false);
      })
    );
  }

  forgotPassword(email: string): Observable<boolean> {
    this.isLoadingSubject.next(true);
    return this.authorizationService.forgotPassword(email).pipe(
      finalize(() => {
        this.isLoadingSubject.next(false);
      })
    );
  }
}
